export default __webpack_public_path__ + "static/media/central-US.b31ea274.jpg";